/**
 * The player's preference for various consent categories, e.g., Analytics, Marketing.
 */
export const ConsentStatuses = Object.freeze({
  /**
   * The player has granted permission.
   */
  Accept: 'ACCEPT',

  /**
   * The player has denied permission.
   */
  Deny: 'DENY',

  /**
   * The player has yet to make a decision.
   */
  Pending: 'PENDING'
})
